type TranslationModule = Record<string, unknown> | { default: Record<string, unknown> };
type TranslationModuleImporter = () => Promise<TranslationModule>;
type TranslationModuleMap = Record<string, TranslationModuleImporter>;

const namespaceToPath = (namespace: string): string =>
  namespace.includes(':') ? namespace.replace(':', '/').replace(/\./g, '/') : namespace;

const createLoadLocaleNamespace =
  (modules: TranslationModuleMap) =>
  async (locale: string, namespace: string): Promise<Record<string, unknown> | undefined> => {
    const modulePath = `./translations/${locale}/${namespaceToPath(namespace)}/index.ts`;
    const importer = modules[modulePath];

    if (!importer) return undefined;

    const module = await importer();
    return ('default' in module ? module.default : module) as Record<string, unknown>;
  };

const eagerGeneralModules = import.meta.glob<TranslationModule>('./translations/de/general/index.ts', {
  eager: true,
});
const lazyModules = import.meta.glob<TranslationModule>([
  './translations/*/**/index.ts',
  '!./translations/de/general/index.ts',
]);

const translationModules: TranslationModuleMap = {
  ...lazyModules,
  ...Object.fromEntries(Object.entries(eagerGeneralModules).map(([path, mod]) => [path, () => Promise.resolve(mod)])),
};

const loadLocaleNamespace = createLoadLocaleNamespace(translationModules);

export { createLoadLocaleNamespace, loadLocaleNamespace };
